import { render } from "./ProfileTemplateCreate.vue?vue&type=template&id=4eed4601"
import script from "./ProfileTemplateCreate.vue?vue&type=script&lang=js"
export * from "./ProfileTemplateCreate.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__